module.exports = __webpack_public_path__ + "static/img/i.e7dfd12.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/i.png
// module id = Lal1
// module chunks = 1